import { observer } from "mobx-react";
import React, { FC } from "react";
import { accountProductsConfigMap } from "constants/account-products-config";
import { ApplicationProductEnum } from "enums/application-product.enum";
import { UserAccountStore } from "store/UserAccounts/UserAccount/UserAccount.store";
import { ProductInfo } from "routes/dashboard/routes/tools/components/ProductInfo/ProductInfo";
import { Box, Center, ListItem, UnorderedList } from "@chakra-ui/react";
import { SplashScreen } from "routes/dashboard/routes/tools/components/SplashScreen/SplashScreen";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/pro-regular-svg-icons";
import { SplashScreenReachout } from "routes/dashboard/routes/tools/components/SplashScreen/SplashScreenReachout";
import { IntegrationShowcase } from "./IntegrationShowcase";

const productConfig =
  accountProductsConfigMap[ApplicationProductEnum.INTEGRATIONS_TAB];

interface IProps {
  accountStore: UserAccountStore;
}

export const IntegrationsSplashScreen: FC<IProps> = observer(
  ({ accountStore }) => {
    return (
      <SplashScreen
        background={"purple.50"}
        topSection={
          <>
            <ProductInfo
              productConfig={productConfig}
              header={"Sync your lead data into your CRM"}
              text={
                "Lead management offers a series of CRM platforms we integrate with, allowing you to push your leads and properties into your CRM."
              }
              customBullet={
                <Center flexShrink={0}>
                  <FontAwesomeIcon icon={faCheckCircle} fontSize={28} />
                </Center>
              }
              bulletPoints={[
                "Manually or automatically sync new leads into your CRM platform",
                "Lead activity and qualification questionnaire responses sync with your leads",
                "Map your CRM agents, offices, sources with their Lead Management counterparts to retain context",
              ]}
              productColor={"purple"}
              colorScheme={"purple"}
              accountBillingStore={accountStore.accountBillingStore}
              customCTA={
                <Box mt={8}>
                  <SplashScreenReachout featureName="Integrations Tab" />
                </Box>
              }
            />
            <Box pt={8}>
              <IntegrationShowcase />
            </Box>
          </>
        }
        bottomSection={
          <>
            <Box fontSize={"xl"}>
              Available CRM integrations:
              <UnorderedList ml={10}>
                <ListItem>Reapit</ListItem>
                <ListItem>Alto</ListItem>
                <ListItem>MRI Qube</ListItem>
                <ListItem>MRI Radar</ListItem>
                <ListItem>Rex</ListItem>
                <ListItem>Street</ListItem>
                <ListItem>Zapier</ListItem>
                <ListItem>iamproperty CRM</ListItem>
              </UnorderedList>
            </Box>
          </>
        }
      />
    );
  }
);
